<template>
  <component  :is="renderer"
              :column="column"
              :has-hide-price="hasHidePrice"
              :has-hide-price-disabled="hasHidePriceDisabled"
              :hide-retail-price="hideRetailPrice"
              :hide-discount-price="hideDiscountPrice"
              :hide-whole-sale-price="hideWholeSalePrice"
              :is-locked="isLocked"
              @togglePrice="toggleHidePriceFromBom">
    <slot />
  </component>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import BomHeaderActions from './BomHeaderActions'
import BomHeaderItem from './BomHeaderItem'
import BomHeaderIndicator from './BomHeaderIndicator'
import BomHeaderName from './BomHeaderName'
import BomHeaderPartNumber from './BomHeaderPartNumber'
import BomHeaderPrice from './BomHeaderPrice'
import BomHeaderQuantity from './BomHeaderQuantity'
import BomHeaderTag from './BomHeaderTag'

export default {
  name: 'BomHeader',
  props: {
    column: {
      type: Object,
      required: true
    }
  },
  components: {
    BomHeaderActions,
    BomHeaderItem,
    BomHeaderIndicator,
    BomHeaderName,
    BomHeaderPartNumber,
    BomHeaderPrice,
    BomHeaderQuantity,
    BomHeaderTag
  },
  computed: {
    ...mapGetters({
      hasHidePrice: 'user/hasHidePrice',
      hasHidePriceDisabled: 'user/hasHidePriceDisabled',
      initiallyHideRetailPrice: 'user/initiallyHideRetailPrice',
      initiallyHideWholesalePrice: 'user/initiallyHideWholesalePrice',
      initiallyHideDiscountedPrice: 'user/initiallyHideDiscountedPrice'
    }),
    ...mapState({
      hideRetailPrice: ({ user }) => user.pricing.hideRetailPrice,
      hideDiscountPrice: ({ user }) => user.pricing.hideDiscountPrice,
      hideWholeSalePrice: ({ user }) => user.pricing.hideWholeSalePrice
    }),
    isLocked () {
      if (this.hasHidePrice) return false
      switch (this.column.property) {
        case 'retail': return this.initiallyHideRetailPrice
        case 'wholesale': return this.initiallyHideWholesalePrice
        case 'discounted': return this.initiallyHideDiscountedPrice
        default: return false
      }
    },
    renderer () {
      switch (this.column.type) {
        case 'price':
          return 'bom-header-price'
        case 'tag':
          return 'bom-header-tag'
        default:
          return `bom-header-${this.column.property}`
      }
    }
  },
  methods: {
    toggleHidePriceFromBom (propertyObject) {
      this.$store.dispatch('user/toggleHidePriceFromBom', propertyObject)
      this.$emit('togglePrice', propertyObject)
    }
  }
}
</script>
